import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faCrown } from '@fortawesome/free-solid-svg-icons';

export default function Footer() {
  return (
    <footer className="bg-navy-900 text-cream relative overflow-hidden">
      {/* Top gold accent line */}
      <div className="h-1 bg-gradient-to-r from-gold-dark via-gold to-gold-dark" />

      {/* Main footer content */}
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-3 gap-12 items-center">
          {/* Logo and tagline */}
          <div className="text-center md:text-left">
            <div className="flex items-center justify-center md:justify-start gap-3 mb-4">
              <img
                src="/logo_ufe.png"
                alt="UFE Roumanie"
                className="h-12 w-auto brightness-0 invert opacity-90"
              />
            </div>
            <h3 className="font-serif text-2xl font-semibold mb-2">UFE Roumanie</h3>
            <p className="font-body text-cream/50 text-sm italic">
              Aucun français n'est seul à l'étranger.
            </p>
          </div>

          {/* Crown decoration */}
          <div className="hidden md:flex justify-center">
            <div className="relative">
              <div className="crown-icon text-5xl opacity-30">
                <FontAwesomeIcon icon={faCrown} />
              </div>
              <div className="absolute inset-0 flex items-center justify-center">
                <span className="font-serif text-gold/80 text-sm uppercase tracking-[0.3em]">
                  2026
                </span>
              </div>
            </div>
          </div>

          {/* Social links */}
          <div className="flex flex-col items-center md:items-end gap-4">
            <span className="font-body text-sm text-cream/40 uppercase tracking-wider">
              Suivez-nous
            </span>
            <div className="flex gap-3">
              <a
                href="https://facebook.com/uferoumanie"
                target="_blank"
                rel="noopener noreferrer"
                className="w-11 h-11 flex items-center justify-center border border-cream/20 text-cream/60 hover:bg-gold hover:text-navy-900 hover:border-gold transition-all duration-300"
                aria-label="Facebook"
              >
                <FontAwesomeIcon icon={faFacebookF} className="text-sm" />
              </a>
              <a
                href="https://instagram.com/uferoumanie"
                target="_blank"
                rel="noopener noreferrer"
                className="w-11 h-11 flex items-center justify-center border border-cream/20 text-cream/60 hover:bg-gold hover:text-navy-900 hover:border-gold transition-all duration-300"
                aria-label="Instagram"
              >
                <FontAwesomeIcon icon={faInstagram} className="text-sm" />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-cream/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-center md:text-left">
            <p className="font-body text-sm text-cream/40">
              &copy; 2026 UFE Roumanie. Tous droits réservés.
            </p>
            <a
              href="https://ufe.ro/"
              target="_blank"
              rel="noopener noreferrer"
              className="font-body text-sm text-cream/40 hover:text-gold transition-colors inline-flex items-center gap-2"
            >
              Visiter le site officiel
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
